module.exports = __webpack_public_path__ + "static/media/count-6.1819655c.mp3";